'use strict';

const { normalizeSearchKeyword } = require('./client');

const VIEW_CONTENT_MARKER = Symbol.for(
    'shopchill.buyer-tracking.view-content'
);
const VIEW_CATEGORY_MARKER = Symbol.for(
    'shopchill.buyer-tracking.view-category'
);
const SEARCH_MARKER = Symbol.for('shopchill.buyer-tracking.search');
const RUNTIME_PROPERTY = 'ShopChillBuyerTrackingRuntime';

function disabled(status = 'adapter_unavailable') {
    return Promise.resolve({ ok: true, status });
}

function positiveInteger(value) {
    const number = Number(value);

    return Number.isInteger(number) && number > 0 ? number : null;
}

function emitOnce(marker, method, input, {
    windowObject = globalThis.window,
    documentObject = globalThis.document,
} = {}) {
    if (!windowObject || !documentObject || documentObject[marker]) {
        return disabled(documentObject && documentObject[marker]
            ? 'duplicate_suppressed'
            : undefined);
    }

    const runtime = windowObject[RUNTIME_PROPERTY];
    if (!runtime || typeof runtime[method] !== 'function') {
        return disabled();
    }

    Object.defineProperty(documentObject, marker, {
        value: true,
        configurable: false,
        enumerable: false,
        writable: false,
    });

    try {
        return Promise.resolve(runtime[method](input))
            .catch(() => ({ ok: false, status: 'client_failure' }));
    } catch (error) {
        return Promise.resolve({ ok: false, status: 'client_failure' });
    }
}

function emitViewContent(input = {}, environment) {
    const productId = positiveInteger(input.productId);
    if (!productId) {
        return disabled('invalid_product_id');
    }

    return emitOnce(VIEW_CONTENT_MARKER, 'trackViewContent', {
        productId,
        pageContext: 'product_detail',
    }, environment);
}

function emitViewCategory(input = {}, environment) {
    const categoryId = positiveInteger(input.categoryId);
    if (!categoryId) {
        return disabled('invalid_category_id');
    }

    return emitOnce(VIEW_CATEGORY_MARKER, 'trackViewCategory', {
        categoryId,
        pageContext: 'category_listing',
    }, environment);
}

function emitSearch(input = {}, environment) {
    const keyword = normalizeSearchKeyword(input.keyword);
    if (!keyword) {
        return disabled('empty_keyword');
    }

    return emitOnce(SEARCH_MARKER, 'trackSearch', { keyword }, environment);
}

function createRequestGeneration() {
    let current = 0;

    return Object.freeze({
        begin: () => {
            current += 1;

            return current;
        },
        isCurrent: (generation) => generation === current,
    });
}

module.exports = {
    SEARCH_MARKER,
    VIEW_CATEGORY_MARKER,
    VIEW_CONTENT_MARKER,
    createRequestGeneration,
    emitSearch,
    emitViewCategory,
    emitViewContent,
};
